import {Observable} from 'rxjs';
import {createLogic} from 'redux-logic';

import {
  timerStart,
  timerCancel,
  timerReset,
  timerEnd,
  timerDecrement,
  timerStartError,
  timerRefreshRequest
} from './actions';

import {selectors as timerSel, timeout} from './reducer';

import * as helper from 'App/util/common/helper';
import {
  authLogout, authLogoutSuccess
} from '../auth/actions';

const cb_logout = (d) => helper.cb_autoLogout(d);

export const timerStartLogic = createLogic({
  type: timerStart,
  cancelType: [timerCancel, timerReset, timerEnd], // any will cancel
  warnTimeout: 0, // disabled warn timeout as this logic could run infinite

  // check to see if it is valid to start, > 0
  validate({getState, action}, allow, reject) {
    const state = getState();
    if (timerSel.status(state) === 'started') {
      // already started just silently reject
      return reject();
    }
    if (timerSel.value(state) > 0) {
      allow(action);
    } else {
      reject(timerStartError(new Error('Can\'t start, already zero. Reset first')));
    }
  },

  // by omitting dispatch and done, process will use the return
  // to determine what to dispatch. In this case we returned
  // an observable so it will dispatch any values that were emitted
  process(depObj) {
    return Observable.interval(1000)
      .map(() => timerDecrement()); // send timerDecrement actions
  }
});

const timerDecrementLogic = createLogic({
  type: timerDecrement,
  cancelType: [authLogoutSuccess],

  validate({getState, action}, allow, reject) {
    const state = getState();
    if (timerSel.value(state) > 0) {
      allow(action);
    } else { // shouldn't get here, but if does end
      reject(timerEnd());
    }
  },

  process({getState}, dispatch, done) {
    // unless other middleware/logic introduces async behavior, the
    // state will have been updated by the reducers before process runs
    const state = getState();
    if (timerSel.value(state) === 0) {
      dispatch(timerEnd());
    }
    done(); // call when done dispatching
  }
});

const timerEndLogic = createLogic({
  type: timerEnd,
  cancelType: [],

  process({getState}, dispatch, done) {
    const state = getState();
    // auto logout
    dispatch(authLogout(cb_logout));

    done(); // call when done dispatching
  }
});

const timerRefreshRequestLogic = createLogic({
  type: timerRefreshRequest,
  cancelType: [authLogoutSuccess],

  process({getState}, dispatch, done) {
    // auto logout
    dispatch(timerReset());
    dispatch(timerStart());

    done(); // call when done dispatching
  }
});

export default [
  timerStartLogic,
  timerDecrementLogic,
  timerEndLogic,
  timerRefreshRequestLogic
];



// WEBPACK FOOTER //
// ./src/util/redux/autoLogout/logic.js